import { Target, Search, Brain, FileText, Layers, Database } from "lucide-react";
import { translations } from "../../i18n";

type Translation = (typeof translations)["de"];

function Features({
  isVisible,
  t,
}: {
  isVisible: (id: string) => boolean;
  t: Translation["features"];
}) {
  const featureIcons = [Target, Search, Brain, FileText, Layers, Database];

  return (
    <section
      id="features"
      data-animate
      className={`py-16 sm:py-24 md:py-32 transition-all duration-1000 ${
        isVisible("features")
          ? "opacity-100 translate-y-0"
          : "opacity-0 translate-y-10"
      }`}
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-center mb-10 sm:mb-14 md:mb-20">{t.heading}</h2>

        <div className="grid md:grid-cols-3 gap-5 sm:gap-6 md:gap-8">
          {t.items.map((feature, idx) => {
            const Icon = featureIcons[idx];
            return (
            <div
              key={feature.title}
              className="p-6 sm:p-8 bg-slate-900/50 border border-slate-800 rounded-2xl hover:border-orange-500/50 transition-all group cursor-pointer hover:bg-slate-900/70 hover:translate-y-[-4px] hover:shadow-xl hover:shadow-orange-500/10"
              style={{ transitionDelay: `${idx * 100}ms` }}
            >
              {Icon ? (
                <Icon className="w-10 h-10 text-orange-500 mb-4 group-hover:scale-110 group-hover:rotate-6 transition-all" />
              ) : null}
              <h3 className="text-xl font-semibold mb-3 group-hover:text-orange-500 transition-colors">
                {feature.title}
              </h3>
              <p className="text-slate-400 group-hover:text-slate-300 transition-colors">
                {feature.desc}
              </p>
            </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default Features;